module.exports = __webpack_public_path__ + "static/media/whatsapp.ba90dc77.svg";